import { SmartEnum } from '../../primitives/smart-enums/models/smart-enum.model';

export function convertObjectToArgs<T extends { [key: string]: any }>(obj: T): any[] {
    return Object.values(obj);
}

export function applyForEachObjectPair<TObj, TKeyValue>(
    obj: { [K in keyof TObj]?: TKeyValue },
    action: (key: string, value: TKeyValue) => void
) {
    Object.keys(obj).forEach(key => {
        const typedKey = key as keyof TObj;
        const value = obj[typedKey];
        action(typedKey.toString(), value as any);
    });
}

function getParentConstructorBeforeConstructorName(constructor: Function, name: string): string {
    let currentPrototype = Object.getPrototypeOf(constructor.prototype);

    while (currentPrototype) {
        const parentConstructor = currentPrototype.constructor;

        if (parentConstructor.name !== name && parentConstructor.name) {
            return parentConstructor.name;
        }

        currentPrototype = Object.getPrototypeOf(currentPrototype);
    }

    return constructor.name;
}

export const objUtils = {
    applyForEachObjectPair,
    convertObjectToArgs,
    getParentConstructorBeforeConstructorName
};
